/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaAttributoValoreDTO } from './tipo-pratica-attributo-valore-dto';


export interface PagedModelTipoPraticaAttributoValoreDTO { 
    content?: Array<TipoPraticaAttributoValoreDTO>;
    page?: PageMetadata;
}

